import { LOCAL_STORAGE_KEY } from "../config";

export const getOptions = (data = [], key, value, item = "Description") => {
  const arr = [...data] ?? [];
  const result = arr.filter((word) => word[key] === value);
  

  return result.length ? result.pop() : { [item]: "" };
};

export const IsLogin = () => {
  const userdata = localStorage.getItem(LOCAL_STORAGE_KEY.user_token);

  if (userdata) {
    return true;
  }

  return false;
};

export const LogOut = () => {
  localStorage.clear();
  window.location.reload(false);
};

// export const IsAdmin = () => {
//   const userData = JSON.parse(
//     localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
//   );
//   if (userData) {
//     return userData.user_roles.includes("ADM");
//   }
// };

// export const IsShowOutstanding = () => {
//   const userData = JSON.parse(
//     localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
//   );
//   if (userData) {
//     return userData.show_outstanding === "true";
//   }
// };
export const IsShowOutstanding = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData?.financePermisionCollection?.statementOfAccount === true;
  }
};
export const IsShowCargoInsurance = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData?.cargoInsurance === true;
  }
};

export const IsShowScheduleSearch = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData?.schedule === true;
  }
};

// export const IsShowOrder = () => {
//   const userData = JSON.parse(
//     localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
//   );
//   if (userData) {
//     return userData.show_orderMangement === "true";
//   }
// };
export const IsShowOrder = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData.order === true;
  }
};
export const IsShowOrderDashboard = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData?.orderPermisionCollection?.orderDashBoard === true;
  }
};
export const IsShowCreateOrder = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData?.orderPermisionCollection?.createOrder === true;
  }
};
export const IsShowOrderList = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData?.orderPermisionCollection?.orderList === true;
  }
};
export const IsShowOrderLog = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData?.orderPermisionCollection?.orderLog === true;
  }
};
export const IsShowOrderReport = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData?.orderPermisionCollection?.orderReport === true;
  }
};

export const IsShowReports = () => {
  const userData = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
  );
  if (userData) {
    return Boolean(userData.show_outstanding);
  }
};

// export const IsShowShipment = () => {
//   const userData = JSON.parse(
//     localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
//   );
//   if (userData) {
//     return userData.show_shipment === "true";
//   }
// };
export const IsShowShipment = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData.shipment === true;
  }
};
export const IsShowShipmentDashboard = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData?.shipmentPermisionCollection?.shipmentDashBoard === true;
  }
};
export const IsShowShipmentList = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData?.shipmentPermisionCollection?.shipmentList === true;
  }
};
export const IsShowShipmentAnalytics = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData?.shipmentPermisionCollection?.shipmentAnalytics === true;
  }
};
export const IsShowShipmentReport = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData?.shipmentPermisionCollection?.shipmentReport === true;
  }
};
export const IsShowShipmentMap = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData?.shipmentPermisionCollection?.shipmentMap === true;
  }
};
export const IsShowShipmentMilestone = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData?.shipmentPermisionCollection?.shipmentMilstone === true;
  }
};
export const IsShowShipmentDetail = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData?.shipmentPermisionCollection?.shipmentDetail === true;
  }
};
export const IsShowShipmentContainer = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData?.shipmentPermisionCollection?.shipmentContainer === true;
  }
};
export const IsShowShipmentDocument = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData?.shipmentPermisionCollection?.shipmentDocument === true;
  }
};
export const IsShowFinance = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData?.finance === true;
  }
};

// export const IsShowRMS = () => {
//   const userData = JSON.parse(
//     localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
//   );
//   // console.log("User data for Show RMS: ", userData);
//   if (userData) {
//     return userData.show_rms === "true";
//   }
// };
export const IsShowRMS = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  // console.log("User data for Show RMS: ", userData);
  if (userData) {
    return userData.rms === true;
  }
};
export const IsShowRMSLCL = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  // console.log("User data for Show RMS: ", userData);
  if (userData) {
    return userData?.rmsPermisionCollection?.rmsLcl === true;
  }
};
export const IsShowRMSFCL = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  // console.log("User data for Show RMS: ", userData);
  if (userData) {
    return userData?.rmsPermisionCollection?.rmsFcl === true;
  }
};
export const IsAminSettingNew = () => {
  const userData = JSON.parse(localStorage.getItem("newTempData"));
  if (userData) {
    return userData?.adminSetting;
  }
};
